import { Platform, type ViewStyle } from 'react-native';

const TEAL_GLOW = 'rgba(0, 196, 180, 0.42)';
const TEAL_GLOW_SOFT = 'rgba(0, 196, 180, 0.22)';
const INK = '#000000';

type ShadowStyle = Pick<
  ViewStyle,
  'shadowColor' | 'shadowOffset' | 'shadowOpacity' | 'shadowRadius' | 'elevation'
> & {
  boxShadow?: string;
};

export const shadows = Platform.select<{
  glowHalo: ShadowStyle;
  glowHaloSoft: ShadowStyle;
  cardAmbient: ShadowStyle;
  cardAmbientStrong: ShadowStyle;
  frosted: ShadowStyle;
  insetAccent: ShadowStyle;
}>({
  ios: {
    glowHalo: {
      shadowColor: '#00C4B4',
      shadowOffset: { width: 0, height: 0 },
      shadowOpacity: 0.42,
      shadowRadius: 24,
    },
    glowHaloSoft: {
      shadowColor: '#00C4B4',
      shadowOffset: { width: 0, height: 0 },
      shadowOpacity: 0.22,
      shadowRadius: 16,
    },
    cardAmbient: {
      shadowColor: INK,
      shadowOffset: { width: 0, height: 12 },
      shadowOpacity: 0.32,
      shadowRadius: 28,
    },
    cardAmbientStrong: {
      shadowColor: INK,
      shadowOffset: { width: 0, height: 20 },
      shadowOpacity: 0.42,
      shadowRadius: 40,
    },
    frosted: {
      shadowColor: INK,
      shadowOffset: { width: 0, height: 6 },
      shadowOpacity: 0.22,
      shadowRadius: 18,
    },
    insetAccent: {
      shadowColor: '#00C4B4',
      shadowOffset: { width: 0, height: 0 },
      shadowOpacity: 0.16,
      shadowRadius: 1,
    },
  },
  android: {
    glowHalo: { elevation: 16 },
    glowHaloSoft: { elevation: 10 },
    cardAmbient: { elevation: 18 },
    cardAmbientStrong: { elevation: 28 },
    frosted: { elevation: 8 },
    insetAccent: { elevation: 2 },
  },
  default: {
    glowHalo: { boxShadow: `0 0 32px ${TEAL_GLOW}, 0 0 1px rgba(0, 196, 180, 0.6) inset` },
    glowHaloSoft: { boxShadow: `0 0 24px ${TEAL_GLOW_SOFT}` },
    cardAmbient: { boxShadow: '0 18px 48px rgba(0, 0, 0, 0.32), 0 2px 6px rgba(0, 0, 0, 0.2)' },
    cardAmbientStrong: {
      boxShadow: '0 32px 80px rgba(0, 0, 0, 0.42), 0 6px 14px rgba(0, 0, 0, 0.28)',
    },
    frosted: { boxShadow: '0 6px 24px rgba(0, 0, 0, 0.22)' },
    insetAccent: { boxShadow: 'inset 0 0 0 1px rgba(0, 196, 180, 0.32)' },
  },
}) as {
  glowHalo: ShadowStyle;
  glowHaloSoft: ShadowStyle;
  cardAmbient: ShadowStyle;
  cardAmbientStrong: ShadowStyle;
  frosted: ShadowStyle;
  insetAccent: ShadowStyle;
};

export type ShadowName = keyof typeof shadows;
export type DarkPrecisionShadowStyle = ShadowStyle;
